import { FOOTER, NAV } from '../constants/tracking';

/* @element - html element
 * checks whether the element given is a footer or nav element
 */
const isFooterOrNav = (element: HTMLElement) => {
    const classList = element?.classList.value.split(' ') || [];
    const exists = classList.filter(
        (elementClass) =>
            elementClass.toLowerCase().includes(FOOTER) || elementClass.toLowerCase().includes(NAV),
    );

    if (exists && exists.length > 0) {
        return exists[0].includes(FOOTER) ? FOOTER : NAV;
    }

    return false;
};

export { isFooterOrNav };
